import { Component, OnInit, ViewChild } from '@angular/core';

import { PageAction } from '../../components/page-actions/page-actions.component';
import { Router } from '@angular/router';
import { ReadmeService } from '@services/readme/readme.service';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-readmes',
    templateUrl: './readmes.component.html',
    styleUrls: ['./readmes.component.scss'],
    providers: [ReadmeService],
    standalone: false
})
export class ReadmesComponent implements OnInit {

  @ViewChild(DataTableComponent) table: DataTableComponent;

  isLoading = true;
  pageActions: PageAction[];

  public columns = [{ prop: 'title' }, { prop: 'name' }, { prop: 'tags' }];

  constructor(
    public readmeService: ReadmeService,
    public dialogService: DialogService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.createPageAction();
    this.isLoading = false;
  }

  createPageAction() {
    this.pageActions = [
      new PageAction({
        icon: 'add',
        title: 'Create readme',
        callback: () => {
          this.router.navigate(['readmes', 'create']);
        }
      })
    ];
  }

  public onEdit(event: DataTableEvent) {
    this.router.navigate(['readmes', event.row._id]);
  }

  public onRemove(event: DataTableEvent) {
    this.dialogService
      .confirm('Remove readme message?')
      .then(res => {
        if (!res) {
          return;
        }
        return this.readmeService.remove(event.row._id).then(() => {
          this.table.refresh();
        }).catch(error => {
          const message = (error.error.message ? error.error.message : error.message);
          return this.dialogService.confirm(message, error.name);
        });
      });
  }

}
